class BaseTransitionParams {
  get type() {
    return this.constructor.TYPE
  }
  static get TYPE() {
    return undefined
  }
}
export default BaseTransitionParams
